import { AbstractModel, DateFormatConstants, DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { get, orderBy } from 'lodash';
import * as moment from 'moment-timezone';
import { Driver } from './driver';
import { InterestedDriver } from './interested-driver';
import { ReservationStatus } from './reservation-status';
import { RideRequestFeedItem } from './ride-request-feed-item';
import { RideRequestLocation } from './ride-request-location';
import { RideRequestType } from './ride-request-type';
import { TransitProgramInfo } from './transit-program-info';

@inheritSerialization(AbstractModel)
export class ProviderDispatchFeedItem {
  @autoserialize
  id: number;

  @autoserialize
  itineraryId: number;

  @autoserialize
  itineraryRideRequestFeedItems: Array<RideRequestFeedItem>;

  @autoserialize
  reservationId: number;

  @autoserialize
  riderId: number;

  @autoserialize
  riderName: string;

  @autoserialize
  passengerCount: number;

  @autoserialize
  distanceEstimate: number;

  @autoserialize
  durationEstimate: number;

  @autoserializeAs(RideRequestType)
  rideRequestType: RideRequestType;

  @autoserialize
  activated: boolean;

  @autoserializeAs(Date)
  activatedAt: Date;

  @autoserialize
  accepted: boolean;

  @autoserializeAs(Date)
  pickupDate: Date;

  @autoserializeAs(RideRequestLocation)
  pickupLocation: RideRequestLocation;

  @autoserializeAs(RideRequestLocation)
  dropoffLocation: RideRequestLocation;

  @autoserialize
  timeZone: string;

  @autoserializeAs(TransitProgramInfo)
  transitProgramInfo: TransitProgramInfo;

  @autoserialize
  polyline: string;

  @autoserializeAs(InterestedDriver)
  interestedDrivers: Array<InterestedDriver>;

  @autoserializeAs(Driver)
  driver: Driver;

  @autoserialize
  riderNote: string;

  @autoserialize
  cancelled: boolean;

  @autoserializeAs(ReservationStatus)
  reservationStatus: ReservationStatus;

  @autoserialize
  ignored: boolean;

  get formattedPickupTime(): string {
    if (isNullOrUndefined(this.pickupDate)) {
      return null;
    }
    return moment.tz(this.pickupDate, this.timeZone).format(DateFormatConstants.TIME);
  }

  get shortTimeZone(): string {
    if (!isNullOrUndefined(this.pickupDate)) {
      return moment.tz(this.pickupDate, this.timeZone).format('z');
    }
  }

  get displayTripDetails(): string {
    if (this.pickupLocation != null && this.dropoffLocation != null && this.pickupDate != null) {
      return this.pickupLocation.display + ' <b>to</b> ' + this.dropoffLocation.display + '<br />';
    } else {
      return 'Error getting trip details';
    }
  }

  static OnDeserialized(instance: ProviderDispatchFeedItem, json: any): void {
    if (!isNullOrUndefined(json['pickupDate'])) {
      instance.pickupDate = DateUtil.deserializeDate(json['pickupDate']);
    }

    if (!isNullOrUndefined(json['activatedAt'])) {
      instance.activatedAt = DateUtil.deserializeDate(json['activatedAt']);
    }

    if (!isNullOrUndefined(instance.itineraryRideRequestFeedItems)) {
      instance.itineraryRideRequestFeedItems = orderBy(
        instance.itineraryRideRequestFeedItems,
        RideRequestFeedItem => [get(RideRequestFeedItem, 'pickupDate', -1), get(RideRequestFeedItem, 'activatedAt')],
        ['asc', 'asc']
      );
    }
  }
}
